import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.KbDateFilter,
    dependencies: [
    ]
})
export class KbDateFilter {
    constructor() {
        return ((d: Date) => {
            return d.getFullYear().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getDate().toString();
        }) as any;
    }
}
